const StudentDetails = () => {
    return (
        <div id="student" className="vision-card">
                <h3>STUDENT DETAILS</h3>

                <div className="table-section-wrap">
                    <table className="table-section">
                        <thead>
                            <tr>
                                <th>CLASS</th>
                                <th>TOTAL NUMBER OF SECTIONS</th>
                                <th>TOTAL NUMBER OF GIRL</th>
                                <th>TOTAL NUMBER OF BOY</th>
                                <th>TOTAL NUMBER OF STUDENTS</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr><td>NUR</td><td>1</td><td>17</td><td>23</td><td>40</td></tr>
                            <tr><td>LKG</td><td>1</td><td>13</td><td>18</td><td>31</td></tr>
                            <tr><td>UKG</td><td>1</td><td>12</td><td>27</td><td>39</td></tr>
                            <tr><td>I</td><td>3</td><td>53</td><td>67</td><td>120</td></tr>
                            <tr><td>II</td><td>3</td><td>45</td><td>73</td><td>118</td></tr>
                            <tr><td>III</td><td>3</td><td>32</td><td>87</td><td>119</td></tr>
                            <tr><td>IV</td><td>3</td><td>50</td><td>70</td><td>120</td></tr>
                            <tr><td>V</td><td>3</td><td>43</td><td>76</td><td>119</td></tr>
                            <tr><td>VI</td><td>4</td><td>59</td><td>89</td><td>148</td></tr>
                            <tr><td>VII</td><td>4</td><td>47</td><td>113</td><td>160</td></tr>
                            <tr><td>VIII</td><td>4</td><td>55</td><td>98</td><td>153</td></tr>
                            <tr><td>IX</td><td>5</td><td>75</td><td>120</td><td>195</td></tr>
                            <tr><td>X</td><td>5</td><td>59</td><td>136</td><td>195</td></tr>
                            <tr><td>XI</td><td>4</td><td>63</td><td>87</td><td>150</td></tr>
                            <tr><td>XII</td><td>4</td><td>62</td><td>78</td><td>140</td></tr>
                            <tr><td></td><td>48</td><td>685</td><td>1162</td><td>1847</td></tr>
                        </tbody>
                    </table>
                </div>
            </div>
    );
};

export default StudentDetails;